import { render } from "./make-sales.vue?vue&type=template&id=40a8014d&scoped=true"
import script from "./make-sales.vue?vue&type=script&lang=js"
export * from "./make-sales.vue?vue&type=script&lang=js"

import "./make-sales.vue?vue&type=style&index=0&id=40a8014d&lang=css"
import "./make-sales.vue?vue&type=style&index=1&id=40a8014d&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a8014d"]])

export default __exports__